import script from "./ButtonApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonApp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__